import ExtensionsGlobal from '../../components/extensionsGlobal/ExtensionsGlobal';

function Extensions({onSubmitForm}) {
    return (
        <ExtensionsGlobal onSubmitForm={onSubmitForm} image="ticketExtensions" text="extensionsTextTicket" continueBtn='paymentSettings' />
    );
}

export default Extensions;
